import GenericViewOffline from '../../GenericViewOffline';

export default class user_checkins_help extends GenericViewOffline {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'user_checkins_help'), data);
    }
}
